import React, { ComponentPropsWithoutRef } from 'react';
import Box from '../../components/Box/Box';

type TAccordionItemProps = ComponentPropsWithoutRef<'details'>;

const AccordionItem = ({ ...rest }: TAccordionItemProps) => {
  return <Box {...rest} as="details" parent="Accordion" name="accordionItem" />;
};

export default AccordionItem;
